import { extendTheme } from "@mui/joy/styles";

/**
 * MUI Joy UI custom theme configuration.
 *
 * - Defines custom color schemes for light and dark modes.
 * - Applies default styling overrides for Joy components like Button, Input, Select, etc.
 * - Sets the font family globally to "Inter".
 *
 * @returns {ReturnType<typeof extendTheme>} The extended MUI Joy theme object.
 */
export default extendTheme({
  colorSchemes: {
    light: {
      palette: {
        background: {
          body: "#f0f0f0",
        },
      },
    },
    dark: {
      palette: {
        background: {
          body: "#1F2A40",
        },
        neutral: {
          outlinedBorder: "var(--joy-palette-neutral-700)",
        },
      },
    },
  },
  components: {
    JoyAutocomplete: {
      styleOverrides: {
        root: {
          boxShadow: "var(--joy-shadow-xs)",
        },
      },
    },
    JoyButton: {
      styleOverrides: {
        root: {
          boxShadow: "var(--joy-shadow-xs)",
        },
      },
    },
    JoyInput: {
      styleOverrides: {
        root: {
          boxShadow: "var(--joy-shadow-xs)",
        },
      },
    },
    JoyTextarea: {
      styleOverrides: {
        root: {
          boxShadow: "var(--joy-shadow-xs)",
        },
      },
    },
    JoySelect: {
      styleOverrides: {
        root: {
          boxShadow: "var(--joy-shadow-xs)",
        },
      },
    },
    JoyStack: {
      defaultProps: {
        useFlexGap: true,
      },
    },
  },
  fontFamily: {
    display: "'Inter', var(--joy-fontFamily-fallback)",
    body: "'Inter', var(--joy-fontFamily-fallback)",
  },
});
